/**
 * Manitoba (MB) and Saskatchewan (SK) firms do not issue a "Retainer", so the
 * ClientConnect UI labels "Written Retainer" as "Agreement" in those provinces.
 * This is a label-only change — the underlying retainer feature is unchanged.
 *
 * Shared by the lawyer-facing ReactShell and the client-facing ClientPortal app.
 */
export const isAgreementProvince = (province?: string | null): boolean =>
  province === 'MB' || province === 'SK';
